import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';

import { ThemeSettings, Password } from './components';
import usePageTitle from '../../hooks/usePageTitle';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4)
  }
}));

const Settings = () => {
  const classes = useStyles();
  usePageTitle('Settings');

  return (
    <div className={classes.root}>
      <Grid container spacing={4}>
        <Grid item md={6} xs={12}>
          <Password />
        </Grid>
        <Grid item md={6} xs={12}>
          <ThemeSettings />
        </Grid>
      </Grid>
    </div>
  );
};

export default Settings;
